//angular imports
import { 
    ChangeDetectionStrategy, 
    Component,
    Inject
} from '@angular/core';

//local imports
import { BUILD_INFO, BuildInfo } from '@core/configuration';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterComponent  {
    public readonly buildLabel: string;
    public readonly buildTooltip: string;

    constructor(
        @Inject(BUILD_INFO) private buildInfo: BuildInfo) {

        this.buildLabel = `v${this.buildInfo.buildNumber}`;
        this.buildTooltip = [
            `Build: ${this.buildInfo.buildNumber}`,
            `Git SHA: ${this.buildInfo.gitSha}`,
            `Build Date: ${this.buildInfo.buildDate}`,
            `Build Machine: ${this.buildInfo.buildMachine}`,
            `Spacebot: ${this.buildInfo.spacebotVersion}`,
        ].join('\n');
    }


}
